/*
 * @Author: shfang
 * @Date: 2022-11-10 09:31:13
 * @LastEditors: shfang
 * @LastEditTime: 2022-11-14 10:22:02
 * @Description: file content
 * @FilePath: \identityserver4web\src\utils\api.js
 */
import { get, post, postFormData, deleteR, put } from "./axios";
import Vue from "vue";
var baseUrl = Vue.prototype.$config.serveUrl + "/api";
const api = {
  common: {},
  account: {
    login: (params) => {
      return post(baseUrl + "/sso/login", params);
    },
    qsLogin: (params) => {
      return post(baseUrl + "/sso/SQLogin", params);
    },
    callback: (params) => {
      return get(baseUrl + params);
    },
    logout: (params) => {
      return post(baseUrl + "/sso/logout", params);
    },
    getImg: (params) => {
      return get(baseUrl + "/sso/GetVerifyCode", params);
    },
    error: (params) => {
      return post(baseUrl + "/sso/error", params);
    },
    getUserInfo: (params) => {
      return get(baseUrl + "/sso/GetLoginInfo", params);
    },
    getClaerList: (params) => {
      return get(baseUrl + "/sso/GetModuleUrls", params);
    },
    isLogin: (params) => {
      return post(baseUrl + "/sso/IsLogin", params);
    },
    getGoEasy: (params) => {
      return get(baseUrl + "/sso/GetGoEasyOTP", params);
    },
    isQRLogin: (params) => {
      return post(baseUrl + "/sso/QRlogin", params);
    },
  },
};
export default api;
